import {
  saveGluceraAuthSession,
  getGluceraRefreshToken,
} from "@/lib/authSession";
import { refreshAccessToken, type TokenPair } from "@/services/tokenRefresh";

export { saveGluceraAuthSession, getGluceraRefreshToken };

/** Extract app JWT tokens from login responses (normal login or staticGoogleLogin). */
export function extractAuthTokens(data: unknown): {
  access: string;
  refresh: string;
} | null {
  if (!data || typeof data !== "object") return null;

  const payload = data as Record<string, unknown>;
  const nested = payload.data as Record<string, unknown> | undefined;
  const tokens = (payload.tokens ?? nested?.tokens) as
    | { access?: string; refresh?: string }
    | undefined;

  const access =
    tokens?.access ??
    (payload.access as string | undefined) ??
    (nested?.access as string | undefined);
  const refresh =
    tokens?.refresh ??
    (payload.refresh as string | undefined) ??
    (nested?.refresh as string | undefined);

  if (!access || !refresh) return null;
  return { access, refresh };
}

/** Detect successful Google/social login across backend response shapes. */
export function isAuthLoginSuccess(data: unknown): boolean {
  if (!data || typeof data !== "object") return false;
  if (extractAuthTokens(data)) return true;

  const payload = data as Record<string, unknown>;
  if (typeof payload.success === "boolean") return payload.success;

  const success = payload.success as { code?: string } | undefined;
  return success?.code?.toLowerCase() === "success";
}

/** Refresh app JWT using the unified token-refresh flow. */
export async function refreshGluceraAuthTokens(): Promise<TokenPair | null> {
  return refreshAccessToken();
}
